import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealskanbanComponent } from './dealskanban.component';

const routes: Routes = [{ path: '', component: DealskanbanComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealskanbanRoutingModule { }
